import axios from 'axios'
import Config from './config'

import Store from '@/store'

import Qs from 'qs'

const instance = axios.create({
    baseURL: Config.apiBaseUrl,
    timeout: 30000
})

instance.defaults.retry = 4
instance.defaults.retryDelay = 1000

// request interceptor
instance.interceptors.request.use(
    config => {
        // do something before request is sent
        return config
    },
    error => {
        // do something with request error
        // console.log(error) // for debug
        return Promise.reject(error)
    }
)

// response interceptor
instance.interceptors.response.use(
    response => {
        const res = response.data
        return res
    }, error => {
        // 处理超时的情况
        const config = error.config
        // If config does not exist or the retry option is not set, reject
        if (!config || !config.retry) return Promise.reject(error)
        // Set the variable for keeping track of the retry count
        config.__retryCount = config.__retryCount || 0
        // Check if we've maxed out the total number of retries
        if (config.__retryCount >= config.retry) {
            // Reject with the error
            return Promise.reject(error)
        }

        // Increase the retry count
        config.__retryCount += 1

        // Create new promise to handle exponential backoff
        const backoff = new Promise((resolve) => {
            setTimeout(() => {
                resolve()
            }, config.retryDelay || 1)
        })

        // Return the promise in which recalls axios to retry the request
        return backoff.then(() => {
            return axios(config)
        })
    }
)

export function $post (url, data, headers) {
    const params = Object.assign(data || {}, {
        client: 'WAP'
    })
    return new Promise((resolve, reject) => {
        instance.post(url, Qs.stringify(params), {
            headers
        }).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

export function $get (url, data, headers) {
    const params = Object.assign(data || {}, {
        client: 'WAP'
    })
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params,
            headers
        }).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

export function $trackPost (url, data) {
    return new Promise((resolve, reject) => {
        instance.post(url, data).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}

export function $getJson (url, data) {
    const params = Object.assign(data || {}, {
        client: 'WAP'
    })
    return new Promise((resolve, reject) => {
        instance.get(url, {
            params
        }).then(res => {
            if (res.status === 0 && res.data) {
                resolve(res)
            } else {
                reject(error)
            }    
        }).catch(error => {
            reject(error)
        })
    })
}


export function $fmPost (url, data) {
    return new Promise((resolve, reject) => {
        instance.post(url, data).then(res => {
            resolve(res)
        }).catch(error => {
            reject(error)
        })
    })
}